import { render, staticRenderFns } from "./default.vue?vue&type=template&id=6848812c&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentfulGlobalBanner: require('/~/src/modules/contentful/components/GlobalBanner.vue').default,Navigation: require('/~/src/modules/opus-ecom/components/Navigation.vue').default,ContentfulGlobalBanner2: require('/~/src/modules/contentful/components/GlobalBanner2.vue').default,Footer: require('/~/src/modules/opus-ecom/components/Footer.vue').default})
